import { useAllContactsSource } from 'legacy/lut/components/widgets/public/partnerContacts/components/tabs/allContactsTab/hooks/useAllContactsSource'
import { useEffect, useMemo, useState } from 'react'

import { IPartnerContact } from 'partner360/features/contacts'

import { mapContactSearchItem } from '../mappers/mapContactSearchItem'
import { IContactSearchItem } from '../models/IContactSearchItem'

interface IParams {
  partnerId: string
  partnerContacts: IPartnerContact[]
}

export const useContactSearch = ({ partnerId, partnerContacts }: IParams) => {
  const [searchString, setSearchString] = useState('')
  const [contacts, setContacts] = useState<IContactSearchItem[]>([])

  const { source } = useAllContactsSource({
    partnerId,
  })

  const filteredOptions = useMemo(() => {
    return contacts.filter((contact) => {
      return (
        contact.fullName.toLowerCase().includes(searchString.toLowerCase()) ||
        contact.email.toLowerCase().includes(searchString.toLowerCase())
      )
    })
  }, [searchString, contacts])

  useEffect(() => {
    if (source) {
      source.setPaging({
        page: 0,
        pageSize: 500,
      })

      source.fetch().then((result) => {
        setContacts(result.items.map((item) => mapContactSearchItem(item, partnerContacts)))
      })
    }
  }, [source, partnerContacts])

  return {
    searchString,
    setSearchString,
    filteredOptions,
  }
}
